let _id = 0;
let _list = new Map();

const FJAudioPlayManager = {
    list: [],
    createId: () => {
        ++_id;
        return _id;
    },
    add: (id, options) => {
        if (!_list.has(id)) {
            _list.set(id, options);
        }

        try {
            _list.forEach((value, key) => {
                if (key !== id) {
                    value?.pause && value.pause();
                }
            });
        } catch (e) {
            console.log(e);
        }
    },
    pauseAll: () => {
        _list.forEach(value => {
            try {
                value?.pause && value.pause();
            } catch (e) {
                console.log(e);
            }
        });
    },
};

export default FJAudioPlayManager;
